module.exports = __webpack_public_path__ + "img/国家荔枝种质资源圃.d874e929.png";